import { holidayCreateSchema } from '@repo/schemas/holiday/createHoliday';
import { HolidayPublic } from '@repo/types/holidays';
import { useQuery } from '@tanstack/react-query';

import type { GetHolidaysParams } from './holidayService';

import { HolidayService } from './holidayService';
import { HolidayKey } from './keys';

export function useGetHolidays(params?: GetHolidaysParams) {
  return useQuery({
    queryKey: [HolidayKey.HOLIDAYS, params],
    placeholderData: [],
    queryFn: async () => {
      const data = await HolidayService.getHolidays(params).then((response) => response.data);
      return data.map<HolidayPublic>((holiday) => ({
        ...holidayCreateSchema.encode(holiday),
        id: holiday.id,
      }));
    },
  });
}
